"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsFields = void 0;
const react_1 = __importStar(require("react"));
const lodash_1 = require("lodash");
const styles_1 = require("@material-ui/core/styles");
const form_panel_1 = require("../../composite/form/fields/form-panel");
const form_table_field_1 = require("../../composite/form/fields/form-table-field");
const form_text_area_1 = require("../../composite/form/fields/form-text-area");
const selector_1 = require("../../composite/form/selectors/selector");
const table_field_context_1 = require("../../components/table-field/table-field-context");
const table_field_row_1 = require("../../components/table-field/table-field-row");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const internal_settings_columns_1 = require("./internal-settings-columns");
const internal_settings_dialog_1 = require("./internal-settings-dialog");
const useStyles = (0, styles_1.makeStyles)((theme) => ({
    comment: {
        border: `1px solid ${theme.palette.grey[300]}`,
        backgroundColor: theme.palette.grey[200],
        margin: '3px 20px 10px',
    },
    row: {
        borderBottom: '1px solid #cdcdcd',
        '&:hover': {
            backgroundColor: `${theme.palette.highlight} !important`,
            cursor: 'pointer',
        },
    },
    description: {
        fontWeight: 400,
        backgroundColor: 'rgba(0, 0, 0, 0.08)',
        padding: '0 16px',
        width: '100%',
        fontSize: 12,
    },
}));
const SettingsFields = () => {
    const settingGroups = (0, selector_1.useFormSelector)((data) => { var _a; return (_a = data === null || data === void 0 ? void 0 : data.settingGroups) !== null && _a !== void 0 ? _a : []; });
    return (react_1.default.createElement(react_1.default.Fragment, null, (settingGroups !== null && settingGroups !== void 0 ? settingGroups : []).map((group, idx) => (react_1.default.createElement(SettingsGroup, { key: group.name, group: group, idx: idx })))));
};
exports.SettingsFields = SettingsFields;
const SettingsGroup = ({ group, idx, }) => {
    const classes = useStyles();
    const collectionDatakey = `settingGroups[${idx}].settings`;
    const columns = (0, internal_settings_columns_1.useColumns)(collectionDatakey);
    const RowComponent = useRowComponent(collectionDatakey);
    const MemoizedTable = (0, react_1.useMemo)(() => function Table() {
        return (react_1.default.createElement(form_table_field_1.FormTableField, { name: collectionDatakey, labelOptions: { hide: true }, visibleAdd: false, layoutOptions: { noSpacing: true }, columns: columns, FormFieldsComponent: internal_settings_dialog_1.InternalSettingsDialog, disabled: false, RowComponent: RowComponent, showRadioCond: lodash_1.stubTrue, createRowStyle: () => ({
                borderBottom: 'none',
            }), visibleRemove: false }));
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return (react_1.default.createElement(form_panel_1.FormPanel, { label: group.name, expandable: true, defaultExpanded: true },
        group.description && (react_1.default.createElement("div", { className: classes.description }, group.description)),
        react_1.default.createElement(MemoizedTable, null)));
};
const useRowComponent = (collectionDataKey) => {
    const classes = useStyles();
    return (0, react_1.forwardRef)(function Row(props, ref) {
        var _a;
        const { disabled, onRowClick, showDetailDialog, showDetailBtnCond, selectRow, showRadioCond, } = (0, react_1.useContext)(table_field_context_1.TableFieldContext);
        const commentDatakey = `${collectionDataKey}[${props.index}].comment`;
        const { comment } = (0, selector_1.useFormSelector)((data) => ({
            comment: (0, lodash_1.get)(data, commentDatakey),
        }));
        const handleSelectClick = (0, event_callback_hook_1.useEventCallback)((e) => {
            e.stopPropagation();
            if (disabled && showDetailBtnCond(props.value)) {
                showDetailDialog(props.index);
            }
            if (!disabled && showRadioCond(props.value)) {
                selectRow(props.index);
            }
        });
        const handleRowClick = (0, event_callback_hook_1.useEventCallback)((e) => {
            if (onRowClick && onRowClick !== lodash_1.noop) {
                onRowClick(props.value, props.index);
            }
            else {
                handleSelectClick(e);
            }
        });
        return (react_1.default.createElement("div", { ref: ref, className: classes.row, onClick: handleRowClick },
            react_1.default.createElement(table_field_row_1.TableFieldRow, { ...props }),
            (comment || !disabled) && (react_1.default.createElement("div", { className: classes.comment },
                react_1.default.createElement(form_text_area_1.FormTextArea, { disabled: !((_a = props === null || props === void 0 ? void 0 : props.value) === null || _a === void 0 ? void 0 : _a.canEdit), name: commentDatakey, labelOptions: { hide: true }, maxRows: 5 })))));
    });
};
//# sourceMappingURL=internal-settings-fields.js.map